import { MediaQueryVariables, ThemeJSON, TypographyVariables } from 'styled-components';

import { ThemeProvider, parseJSONTheme, createTheme } from '@toqio/toqio-web-components';
import ClientColors from 'theme/colors.json';
import { DefaultTheme } from 'styled-components/dist/types';

try {
  require('theme/fonts.css'); 
} catch (error) {
  console.error('Error loading fonts.css', error);
}

const media_queries = {
  mobileXS: '320px',
  mobileS: '576px',
  mobileM: '768px',
  desktopL: '992px',
  desktopXL: '1200px',
  desktopXXL: '1440px',
  mdMobileGtXs: '600px',
};

// MEDIA QUERIES
const getMediaQueries = (): { media_queries: MediaQueryVariables } => ({
  media_queries: {
    //------------
    // Bootstrap
    //------------
    /* Custom, iPhone Retina */
    mediaXS: `only screen and (min-width: ${media_queries.mobileXS})`,
    /* Extra Small Devices, Phones */
    mediaS: `only screen and (min-width: ${media_queries.mobileS})`,
    /* Small Devices, Tablets */
    mediaM: `only screen and (min-width: ${media_queries.mobileM})`,
    /* Medium Devices, Desktops */
    mediaL: `only screen and (min-width: ${media_queries.desktopL})`,
    /* Large Devices, Wide Screens */
    mediaXL: `only screen and (min-width: ${media_queries.desktopXL})`,
    /* Extra Large Devices, Wide Screens */
    mediaXXL: `only screen and (min-width: ${media_queries.desktopXXL})`,
    //------------
    // angular-material
    //------------
    /* bigger than XS (600px) */
    mdMediaGtXs: `only screen and (min-width: ${media_queries.mdMobileGtXs})`,
  },
});

// FONT
const getFont = (variables: ThemeJSON): { typography: TypographyVariables } => ({
  typography: {
    fontFamily: variables.font_family,
    fontWeight: variables.font_base_weight,
  },
});

const getTheme = (colors: ThemeJSON): DefaultTheme => {
  return createTheme({
    ...getFont(colors),
    ...getMediaQueries(),
    ...parseJSONTheme(colors),
    // Table flowable
    table: {
      header: {
        label: colors.table_header_label,
        background: colors.table_header_background,
        text_field: {
          font: colors.table_header_text_field_font,
          border: colors.table_header_text_field_border,
          background: colors.table_header_text_field_background,
        },
      },
    },
  });
};

const theme = getTheme(ClientColors);

export { ThemeProvider, getTheme, theme };
